'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  _lazyImage.options.afterLoad = calculate;
  _lazyImage.options.onError = calculate;

  (0, _lazyImage2.default)();
};

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calculate = function calculate(img) {
  // inspiration https://stackoverflow.com/questions/280049/how-to-create-a-javascript-callback-for-knowing-when-an-image-is-loaded
  function loaded() {
    (0, _linksoftAlbatros.boxHeight)(img);
  }

  if (img[0].complete) {
    loaded();
  } else {
    img[0].addEventListener('load', loaded);
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/lazyloadImage.js
// module id = 576
// module chunks = 0 1